export default __webpack_public_path__ + "static/media/DOS.54194044.xml";